import { render, staticRenderFns } from "./aiOrder.vue?vue&type=template&id=7e35fb2e&scoped=true"
import script from "./aiOrder.vue?vue&type=script&lang=js"
export * from "./aiOrder.vue?vue&type=script&lang=js"
import style0 from "./aiOrder.vue?vue&type=style&index=0&id=7e35fb2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e35fb2e",
  null
  
)

export default component.exports